import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BuilderSectionsInteractionService} from "../../../../../../builder-sections-interaction.service";
import {FormControl, Validators} from "@angular/forms";
import {DbValidators} from "../../../../../../../shared/validators/DbValidators";
import {CommonBuilderDataService} from "../../../../../../services/common-builder-data.service";

@Component({
    selector: 'db-site-info-edit',
    templateUrl: './site-info-edit.component.html',
    styleUrl: './site-info-edit.component.scss',
    standalone: false
})
export class SiteInfoEditComponent implements OnInit {
  isEditName = false;
  @Output() openDescription = new EventEmitter<void>();
  titleForm: FormControl = new FormControl('', [DbValidators.trimStart, Validators.required]);

  constructor(
      public builderInteractionsService: BuilderSectionsInteractionService,
      public commonDataService: CommonBuilderDataService
  ) {
  }

  ngOnInit() {
  }

  onEdit(title: string) {
    this.isEditName = true;
    this.titleForm.setValue(title);
  }

  saveEdited(title: string) {
    if (this.titleForm.invalid || !this.titleForm.value) {
      this.isEditName = false;
      return;
    }
    this.isEditName = false;
    const siteValue = this.builderInteractionsService.siteInfo.value;
    this.builderInteractionsService.siteInfo.next({...siteValue, business_name: title});
  }
}
